export default __webpack_public_path__ + "static/media/previewimg.15548173.png";